import dividerClasses from "@mui/material/Divider/dividerClasses";
export const MuiDividerTheme = (dt) => {
    const vertical = `&.${dividerClasses.vertical}`;
    const horizontal = `&:not(.${dividerClasses.vertical})`;
    return {
        styleOverrides: {
            root: {
                [horizontal]: {
                    minHeight: dt.size.xSmall5,
                    [`&.${dividerClasses.middle}`]: {
                        marginLeft: dt.space.inline.small,
                        marginRight: dt.space.inline.small,
                    },
                    "&::before, &::after": {
                        borderTop: `${dt.size.xSmall5} solid ${dt.color.outlineVariant}`,
                    },
                },
                [vertical]: {
                    minWidth: dt.size.xSmall5,
                    [`&.${dividerClasses.middle}`]: {
                        marginTop: dt.space.inline.small,
                        marginBottom: dt.space.inline.small,
                    },
                    "&::before, &::after": {
                        borderLeft: `${dt.size.xSmall5} solid ${dt.color.outlineVariant}`,
                    },
                },
            },
        },
    };
};
